import { FC, ReactNode } from "react";

import { Box, BoxProps, FlexboxProps, SpaceProps } from "@hightouch/htui";

export type SelectableProps = SpaceProps &
  FlexboxProps & {
    width?: BoxProps["width"];
    height?: BoxProps["height"];
    bg?: BoxProps["bg"];
    overflow?: BoxProps["overflow"];
    textAlign?: BoxProps["textAlign"];
    children: ReactNode;
    selected: boolean | undefined;
    onSelect: () => void;
    disabled?: boolean;
    allowDeselect?: boolean;
  };

export const Selectable: FC<Readonly<SelectableProps>> = ({
  children,
  selected,
  onSelect,
  disabled,
  allowDeselect = false,
  bg = "white",
  ...props
}) => {
  const keyPress = (key: string) => {
    if (key === "Enter") {
      onSelect();
    }
  };

  return (
    <Box
      as="button"
      display="flex"
      alignItems="center"
      {...props}
      aria-pressed={selected}
      disabled={disabled}
      position="relative"
      borderRadius="md"
      bg={selected ? "primary.background" : bg}
      borderWidth="hairline"
      borderStyle="solid"
      borderColor={selected ? "primary.border" : "base.border"}
      pointerEvents={selected && !allowDeselect ? "none" : "auto"}
      transitionProperty="common"
      transitionDuration="fast"
      transitionTimingFunction="easeOutQuad"
      outline="none !important"
      _hover={{
        bg: disabled
          ? undefined
          : selected && allowDeselect
            ? "primary.backgroundHover"
            : "base.background",
      }}
      _focusVisible={{
        boxShadow: "outline",
      }}
      cursor={disabled ? "default" : "pointer"}
      onClick={disabled ? undefined : onSelect}
      onKeyPress={(event: any) => {
        if (!disabled) {
          keyPress(event.key);
        }
      }}
    >
      {children}
    </Box>
  );
};
